import React, { useState, useEffect } from "react";
import "./ProfilePage.css";
import Header from "../../components/Navbar";
import UpcommingBid from "../../components/upcomming_auction/upcomming_auction";
import Mybids from "../../components/mybids/mybids";
import Favorite from "../../components/favorite/favorite";
import Accountsettings from "../../components/accountsettings/accountsettings";
import AddpropertyDetails from "../../components/addpropertydetails/addpropertydetails";
import MyListings from "../../components/mylisting/mylisting";
import Purchagerequest from "../../components/purchangerequest/purchangerequest";
import Purchageprofile from "../../components/Purchageprofile/Purchageprofile";
import Swal from "sweetalert2";
import rigtrow from "../../myimgs/fast-forward.png";
import Addpropertybymls from "../AddpropertyByMls/AddpropertyByMls"


function ProfilePage() {
  const [activeTab, setActiveTab] = useState("profile");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);

  //Detect screen size change
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setSidebarOpen(!mobile); //auto-close on mobile
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = (tabName) => {
    setActiveTab(tabName);
    if (isMobile) setSidebarOpen(false); // close only on mobile
  };

  const renderContent = () => {
    switch (activeTab) {
      case "profile":
        return <ProfileForm />;
      case "upcoming":
        return <UpcommingBid />;
      case "bids":
        return <Mybids />;
      case "Purchagerequest":
        return <Purchagerequest />;
      case "Purchageprofile":
        return <Purchageprofile />;
      case "favorites":
        return <Favorite />;
      case "Properties":
        return <AddpropertyDetails />;
      case "Addpropertybymls":
        return <Addpropertybymls />;
      case "Listings":
        return <MyListings />;
      default:
        return null;
    }
  };

  return (
    <>
      <Header />
      <div className="profile-container container-fluid scrolleffect">
        <div className="row">
          {/* Sidebar */}
          {(sidebarOpen || !isMobile) && (
            <div className="col-md-2">
              <aside
                className={`sidebar ${
                  isMobile && !sidebarOpen ? "hidden" : ""
                }`}
              >
                <ul>
                  <div className="buyer-header">
                    <h2>Buyer</h2>
                    {isMobile && (
                      <span
                        className="close-icon"
                        onClick={() => setSidebarOpen(false)}
                      >
                        ✕
                      </span>
                    )}
                  </div>

                  <li
                    className={activeTab === "profile" ? "active" : ""}
                    onClick={() => handleMenuClick("profile")}
                  >
                    My Profile
                  </li>
                  <li
                    className={activeTab === "upcoming" ? "active" : ""}
                    onClick={() => handleMenuClick("upcoming")}
                  >
                    My Upcoming Offers
                  </li>
                  <li
                    className={activeTab === "bids" ? "active" : ""}
                    onClick={() => handleMenuClick("bids")}
                  >
                    My Offers
                  </li>
                  <li
                    className={activeTab === "Purchagerequest" ? "active" : ""}
                    onClick={() => handleMenuClick("Purchagerequest")}
                  >
                    My Purchase Request
                  </li>
                  <li
                    className={activeTab === "Purchageprofile" ? "active" : ""}
                    onClick={() => handleMenuClick("Purchageprofile")}
                  >
                    My Purchase Profiles
                  </li>
                  <li
                    className={activeTab === "favorites" ? "active" : ""}
                    onClick={() => handleMenuClick("favorites")}
                  >
                    Favorites
                  </li>
                </ul>

                <div className="line">
                  <ul className="ul2">
                    <h2>Seller</h2>
                    <li
                      className={activeTab === "Properties" ? "active" : ""}
                      onClick={() => handleMenuClick("Properties")}
                    >
                      Add Properties
                    </li>
                    <li
                      className={activeTab === "Addpropertybymls" ? "active" : ""}
                      onClick={() => handleMenuClick("Addpropertybymls")}
                    >
                      Add Propertie By MLS
                    </li>
                    <li
                      className={activeTab === "Listings" ? "active" : ""}
                      onClick={() => handleMenuClick("Listings")}
                    >
                      My Listings
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          )}

          {/* Open button only on mobile */}
          {isMobile && !sidebarOpen && (
            <button
              className="open-sidebar-btn"
              onClick={() => setSidebarOpen(true)}
            >
              <img src={rigtrow} alt="" />
            </button>
          )}

          <div className="col-md-10">
            <main className="content">{renderContent()}</main>
          </div>
        </div>
      </div>
    </>
  );
}

function ProfileForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [state, setStates] = useState("");
  const [city, setCity] = useState("");
  const [pincode, setPincode] = useState("");
  const [sincode, setSincode] = useState("");
  const [phone, setPhone] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [documents, setDocuments] = useState(null);

  const userId = localStorage.getItem("userId");

  useEffect(() => {
    if (!userId) return;

    const fetchData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/user/edit/${userId}`
        );
        const result = await response.json();

        if (result.status === 200 && result.data) {
          const data = result.data;
          setName(data.name || "");
          setEmail(data.email || "");
          setPhone(data.phone || "");
          setAddress(data.address || "");
          setStates(data.state || "");
          setCity(data.city || "");
          setPincode(data.pincode || "");
          setSincode(data.sincode || "");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [userId]);

  //Handle Update Profile
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !email) {
      alert("Please fill all required fields!");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("id", userId);
      formData.append("name", name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("city", city);
      formData.append("state", state);
      formData.append("pincode", pincode);
      formData.append("address", address);
      formData.append("sin", sincode);
      if (profileImage) {
        formData.append("profileImage", profileImage);
      }
      if (documents) {
        formData.append("documents", documents);
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/user/update`,
        {
          method: "POST",
          body: formData,
        }
      );

      const result = await response.json();
      console.log("Update Response:", result);

      if (result.status === 200) {
        alert("Profile updated successfully!");
      } else {
        alert(result.message || "Something went wrong while updating profile!");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      alert("Failed to update profile!");
    }
  };

  const handleDeleteAccount = async () => {
    if (!userId) {
      Swal.fire("Error", "User not found!", "error");
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete your account? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) {
      Swal.fire("Cancelled", "Your account is safe.", "info");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/user/delete/${userId}`,
        {
          method: "PUT",
        }
      );

      const resultData = await response.json();
      console.log("Delete Response:", resultData);

      if (resultData.status === 200) {
        await Swal.fire(
          "Deleted!",
          "Your account has been deleted successfully.",
          "success"
        );
        localStorage.clear();
        window.location.href = "/";
      } else {
        Swal.fire(
          "Error",
          resultData.message || "Failed to delete account!",
          "error"
        );
      }
    } catch (error) {
      console.error("Error deleting account:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting your account.",
        "error"
      );
    }
  };

  return (
    <div className="profile-form">
      <div className="form-header">
        <h2>Profile Information</h2>
        <button
          type="button"
          className="save-btn chngwd"
          onClick={() => setShowPopup(true)}
        >
          Change Password
        </button>
      </div>

      <form className="proinfo" onSubmit={handleSubmit}>
        <div className="form-row">
          <label>
            Name <span className="dotespan">*</span>
          </label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            readOnly
          />
        </div>

        <div className="form-row">
          <label>
            Email <span className="dotespan">*</span>
          </label>
          <input type="email" value={email} readOnly />
        </div>

        <div className="form-row">
          <label>Address</label>
          <input
            type="text"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Province</label>
          <input
            type="text"
            value={state}
            onChange={(e) => setStates(e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>City</label>
          <input
            type="text"
            value={city}
            onChange={(e) => setCity(e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Postal Code</label>
          <input
            type="text"
            value={pincode}
            onChange={(e) => setPincode(e.target.value)}
          />
        </div>

        <div className="form-row">
          <label>Mobile</label>
          <input
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        {/* <div className="form-row">
          <label>
            Sin Code <span className="dotespan">*</span>
          </label>
          <input
            type="text"
            value={sincode}
            onChange={(e) => setSincode(e.target.value)}
          />
        </div> */}

        <div className="form-row">
          <label>Profile Image</label>
          <input
            type="file"
            onChange={(e) => setProfileImage(e.target.files[0])}
          />
        </div>

        <div className="form-row">
          <label>Upload Documents (PDF / Image)</label>
          <input
            type="file"
            accept=".pdf,.jpg,.jpeg,.png"
            onChange={(e) => setDocuments(e.target.files[0])}
          />
        </div>

        <div className="form-actions">
          {/* Delete Account Button with API */}
          <button
            type="button"
            className="delete-btn"
            onClick={handleDeleteAccount}
          >
            Delete Your Account
          </button>

          <button type="submit" className="save-btn">
            SAVE
          </button>
        </div>
      </form>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-contents">
            <div className="cunbn">
              <button className="cutbtn" onClick={() => setShowPopup(false)}>
                ✕
              </button>
            </div>
            <Accountsettings />
          </div>
        </div>
      )}
    </div>
  );
}

export default ProfilePage;
